export const homepageCategories = [
  { key: 'bearingCapacity', label: 'Bearing Capacity' },
  { key: 'slopeStability', label: 'Slope Stability' },
  { key: 'settlementAndCompressibility', label: 'Settlement' },
  { key: 'siteCharacterization', label: 'Site Characterization' },
  { key: 'parameterEstimation', label: 'Parameter Estimation' },
  { key: 'stressIncrease', label: 'Stress Increase' },
];

const allCalculationsData = [
  // CALCULATION TOOLS AVAILABLE
  {
    title: 'SPT Corrections',
    description: 'Calculate N₆₀ and (N₁)₆₀ values for a given borehole log.',
    link: '/calculations/spt-corr',
    theoryLink: '/spt-corr-theory',
    id: 1,
    category: 'siteCharacterization',
    className: 'box',
  },
  {
    title: "Bearing Capacity of Shallow Foundations | Terzaghi's Method",
    description: 'Calculate bearing capacity of shallow foundations in soil. Terzaghi (1943)',
    link: '/calculations/terzaghi',
    theoryLink: '/terzaghi-theory',
    id: 2,
    category: 'bearingCapacity',
    className: 'box',
  },
  {
    title: "Bearing Capacity of Shallow Foundations | Meyerhof's Method",
    description: 'Calculate bearing capacity of shallow foundations in soil. Meyerhof (1963)',
    link: '/calculations/meyerhof',
    theoryLink: '/meyerhof-theory',
    id: 3,
    category: 'bearingCapacity',
    className: 'box',
  },

  {
    title: 'Bearing Capacity of Pile Foundations',
    description: 'Calculate bearing capacity of pile foundations in rock. AASHTO (2002)',
    link: '/calculations/pile-rock-bc',
    theoryLink: '/pile-rock-bc-theory',
    id: 4,
    category: 'bearingCapacity',
    className: 'box',
  },
  {
    title: 'Soil Liquefaction',
    description: 'Calculate soil liquefaction safety factors based on SPT values for a given borehole log.',
    link: '/calculations/liquefaction-tbdy',
    theoryLink: '/liquefaction-tbdy-theory',
    id: 5,
    category: 'siteCharacterization',
    className: 'box',
  },
  {
    title: 'Settlement (Pile Foundations)',
    description: 'Calculate immediate settlement of piles in rock. AASHTO (2002)',
    link: '/calculations/pile-rock-settle-aashto2002',
    theoryLink: '/pile-rock-settle-aashto2002-theory',
    id: 6,
    category: 'settlementAndCompressibility',
    className: 'box',
  },
  {
    title: 'Settlement (Shallow Foundations)',
    description: 'Calculate time dependent settlements of shallow foundations in soil.',
    link: '/calculations/consolidation',
    theoryLink: '/consolidation-theory',
    id: 7,
    category: 'settlementAndCompressibility',
    className: 'box',
  },
  {
    title: 'Average c–φ Calculation for Layered Soils',
    description: 'Calculate cₐᵥ and φₐᵥ for layered soils to use in bearing capacity calculations for shallow foundations.',
    link: '/calculations/layered-soil',
    theoryLink: '/layered-soil-theory',
    id: 8,
    category: 'parameterEstimation',
    className: 'box',
  },
  {
    title: "Bearing Capacity of Shallow Foundations | Hansen's Method",
    description: 'Calculate bearing capacity of shallow foundations in soil. Hansen (1970)',
    link: '/calculations/hansen',
    theoryLink: '/hansen-theory',
    id: 9,
    category: 'bearingCapacity',
    className: 'box ',
  },
  {
    title: 'Weight - Volume Relationships',
    description:
      'Calculate soil properties like void ratio, porosity, degree of saturation, specific gravitiy, saturated unit weight and more.',
    link: '/calculations/weightVolumeRelations',
    theoryLink: '/weightVolumeRelations-theory',
    id: 10,
    category: 'parameterEstimation',
    className: 'box ',
  },
  {
    title: 'cᵤ–mᵥ & SPT–PI Relationships',
    description: 'Calculate undrained shear strength (cᵤ) and coefficient of volume compressibility (mᵥ) of clays. Stroud (1974)',
    link: '/calculations/stroud',
    theoryLink: '/stroud-theory',
    id: 11,
    category: 'parameterEstimation',
    className: 'box ',
  },
  {
    title: 'Plasticity Index Vs Effective Friction Angle Relationships',
    description:
      'Calculate effective friction angle of clays with 3 approaches. Terzaghi, Peck, Mesri 1996 - Kenny 1959 - Gibson 1953',
    link: '/calculations/clayEffectiveFrictionAngle',
    theoryLink: '/clayEffectiveFrictionAngle-theory',
    id: 12,
    category: 'parameterEstimation',
    className: 'box ',
  },
  {
    title: 'Liquid Limit vs Coefficient of Consolidation of Clays',
    description: 'Calculate coefficient of consolidation (cᵥ) of clays using liquid limit (LL). US Navy (1982)',
    link: '/calculations/cvLLUsNavy',
    theoryLink: '/cvLLUsNavy-theory',
    id: 13,
    category: 'parameterEstimation',
    className: 'box ',
  },
  {
    title: 'Vertical Stress Increase Due to Surface Loads',
    description: 'Calculate vertical stress increase at a depth due to surface loads by 60 degree method and 1H:2V method.',
    link: '/calculations/stressIncrease',
    theoryLink: '/stressIncrease-theory',
    id: 14,
    category: 'stressIncrease',
    className: 'box ',
  },
  {
    title: 'USCS Soil Classifier',
    description: 'Get the USCS symbol and group name from sieve data and Atterberg limits based on ASTM D2487-17.',
    link: '/calculations/uscsClassifier',
    theoryLink: '/uscsClassifier-theory',
    id: 15,
    category: 'siteCharacterization',
    className: 'box ',
    new: false,
  },
  {
    title: 'Vs₃₀ & Site Class (EC8)',
    description:
      'Determine the average shear wave velocity (Vs₃₀) and corresponding ground type (A–E, S1, S2) based on Eurocode 8.',
    link: '/calculations/vs30SiteClassEc8',
    theoryLink: '/vs30SiteClassEc8-theory',
    id: 16,
    category: 'siteCharacterization',
    className: 'box ',
    new: false,
  },
  {
    title: 'Slope Stability',
    description:
      'Analyze circular slip surfaces with a single drained material and horizontal water table using Bishop Simplified method.',
    link: '/calculations/slope-stability',
    theoryLink: '/slope-stability-theory',
    id: 17,
    category: 'slopeStability',
    className: 'box ',
    new: true,
  },
  {
    title: 'Interactive Mohr Circle',
    description:
      'Transform plane stresses, compute principal stresses and maximum shear stress, and visualize the stress state on an interactive Mohr circle.',
    link: '/calculations/mohr-circle',
    theoryLink: '/mohr-circle-theory',
    id: 18,
    category: 'parameterEstimation',
    className: 'box ',
    new: true,
  },
  {
    title: 'Stone Columns | Priebe Vibro Replacement',
    description:
      'Calculate Priebe improvement factors, footing settlement reduction, residual stress, and bearing-capacity effects for vibro replacement.',
    link: '/calculations/priebe',
    theoryLink: '/priebe-theory',
    id: 19,
    category: 'settlementAndCompressibility',
    className: 'box ',
    new: true,
    hideInProduction: true,
  },
];

export const calculationsData =
  process.env.NODE_ENV === 'production'
    ? allCalculationsData.filter((calculation) => !calculation.hideInProduction)
    : allCalculationsData;
